import { render, staticRenderFns } from "./CuentasBancariasFormComponent.vue?vue&type=template&id=065f05e0&"
import script from "./CuentasBancariasFormComponent.vue?vue&type=script&lang=js&"
export * from "./CuentasBancariasFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports